import React from "react";

const TimesheetFilterField = ({
  label,
  children,
  className = "",
  controlClassName = "",
}) => (
  <div className={`flex min-w-0 flex-col gap-1 ${className}`}>
    <span className="block h-[10px] text-[10px] font-semibold leading-[10px] tracking-wide text-[#94A3B8]">
      {label}
    </span>
    <div
      className={`flex min-h-[34px] w-full items-center ${controlClassName}`}
    >
      {children}
    </div>
  </div>
);

export default TimesheetFilterField;
